import { GroupModel } from "models";
import { apiMiddleware } from "../api.middleware";

export const getGroups = apiMiddleware<GroupModel[]>()({
  method: "get",
  endpoint: "/groups",
});
